<template>
  <div id="app">
   
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="container-fluid">
        <a class="navbar-brand">Repositorio</a>

        <div class="navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">

          </ul>

          <div class="d-flex">          
            <input v-model="search" class="form-control me-2" type="search" placeholder="Buscar" aria-label="Search" v-on:keyup.enter="searchpublications">
            <button class="btn btn-outline-success" v-on:click="searchpublications">Buscar</button>
          </div>
        </div>
      </div>
    </nav>

    <div class="container">
      <div class="row">
        <v-pagination v-model="page"
                      :page-count="pages"
                      @input="changePage"
                      :classes="bootstrapPaginationClasses"
                      :labels="paginationAnchorTexts"></v-pagination>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <ul>
          <publication 
          v-for="publication of publications" 
          v-bind:key="publication.id" 
          v-bind:publication="publication" 
          />
        </ul>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <v-pagination v-model="page"
                      :page-count="pages"
                      @input="changePage"
                      :classes="bootstrapPaginationClasses"
                      :labels="paginationAnchorTexts"></v-pagination>
      </div>
    </div>

  </div>
</template>

<script>
// Librerías
import axios from "axios";

import Publication from './components/Publication';
//import Pagination from './components/Pagination';
import vPagination from 'vue-plain-pagination'

export default {
  name: 'App',
  components: {
  Publication,
  //Pagination,
  vPagination
  },
  
  data: function() {
    return {
      publications: [],
      page: 1,
      pages: 1,
      search: "",
      modal: false,
      currentPublication: {},

      paginaActual: 1,
      itemsPorPagina: 20,


      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'  
      },
      /*paginationAnchorTexts: {
        first: 'Primero',
        prev: 'Anterior',
        next: 'Próximo',
        last: 'Último'
      }*/
    };
  },

  created() {
    this.fetch()
  },

  methods: {
    fetch() {      
      const params = {
        page: this.page,
        search: this.search
      }
      
      let result = axios
        .get('https://app.fundacionbengoa.org/api/publications', { params })
        .then (res => {
          this.publications = res.data.data;
          this.pages = res.data.meta.last_page;
          //console.log(res.data);
        })
        .catch((err)  => {
          console.log(err)
        })
    },
    
    changePage(page) {
      this.page = (page <= 0 || page > this.pages) ? this.page : page;
      this.fetch();
      window.scroll(0,0);
    },

    searchpublications() {
      this.page = 1;
      this.fetch();
    },
  }
}
</script>
